import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=8c918940&scoped=true"
import script from "./Publish.vue?vue&type=script&lang=js"
export * from "./Publish.vue?vue&type=script&lang=js"
import style0 from "./Publish.vue?vue&type=style&index=0&id=8c918940&prod&scoped=true&lang=less"
import style1 from "./Publish.vue?vue&type=style&index=1&id=8c918940&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c918940",
  null
  
)

export default component.exports